import QuotationService from '_services/rest/modules/quotation';
import { ROW } from '_modules/quotation/components/QuotationModel';

export default {
  state: {
    quotation: null,
    blindsTypes: null,
    typeOptions: null,
    productUnits: null,
    quotationList: null,
    paymentTypeOptions: null,
  },
  mutations: {
    setBlindsType(state, response) {
      state.blindsTypes = response;
    },
    setProductUnits(state, response) {
      state.productUnits = response;
    },
    setQuotation(state, response) {
      state.quotation = response;
      if (response.rows.length === 0) {
        state.quotation.rows = [{ ...ROW }];
      }
    },
    setQuotationList(state, response) {
      state.quotationList = response;
    },
    setPaymentTypeOptions(state, response) {
      state.paymentTypeOptions = response;
    },
    setTypeOptions(state, response) {
      state.typeOptions = response;
    },
  },
  actions: {
    getBlindsTypes({ commit }) {
      return QuotationService.getBlindsTypes()
        .then(response => {
          commit('setBlindsType', response);
        });
    },
    getProductUnits({ commit }, params) {
      return QuotationService.getProductUnits(params)
        .then(response => {
          commit('setProductUnits', response);
        });
    },
    getQuotation({ commit }, params) {
      return QuotationService.getQuotationById(params)
        .then(response => {
          commit('setQuotation', response);
        });
    },
    getQuotationList({ commit }, params) {
      return QuotationService.getList(params)
        .then(response => {
          commit('setQuotationList', response);
        });
    },
    getTypeOptions({ commit }) {
      return QuotationService.getTypeOptions()
        .then(response => {
          commit('setTypeOptions', response);
        });
    },
    getPaymentTypeOptions({ commit }) {
      return QuotationService.getPaymentTypeOptions()
        .then(response => {
          commit('setPaymentTypeOptions', response);
        });
    },
  },
};
